import { render, staticRenderFns } from "./home-layout.vue?vue&type=template&id=672c5e1a&scoped=true&"
import script from "./home-layout.vue?vue&type=script&lang=js&"
export * from "./home-layout.vue?vue&type=script&lang=js&"
import style0 from "./home-layout.vue?vue&type=style&index=0&id=672c5e1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c5e1a",
  null
  
)

export default component.exports